import { useSelector } from "react-redux";

import ModalHeader from "app/pages/sales-intelligence/sub-modules/signals/components/modals/SignalsModal/ModalHeader/ModalHeader";
import ModalHeaderContent from "app/pages/sales-intelligence/sub-modules/signals/components/modals/SignalsModal/ModalHeaderContent/ModalHeaderContent";
import SignalsModal from "app/pages/sales-intelligence/sub-modules/signals/components/modals/SignalsModal/SignalsModal";
import type {
    SignalManagementViewProps,
} from "app/pages/sales-intelligence/sub-modules/signals/components/views/SignalsManagementView/SignalsManagementView";
import SignalsManagementView from "app/pages/sales-intelligence/sub-modules/signals/components/views/SignalsManagementView/SignalsManagementView";
import { selectSignalsSource } from "app/pages/sales-intelligence/sub-modules/signals/store/selectors";

import { MODAL_CONTENT_BY_SOURCE } from "./const";

export type SignalManagementModalProps = SignalManagementViewProps & {
    isOpen: boolean;
    onClose(): void;
};

const SignalsManagementModal = (props: SignalManagementModalProps) => {
    const signalsSource = useSelector(selectSignalsSource);
    const { isOpen, viewModel, initialSelectedType, onClose, onSignalCreate, onSignalEdit, onSignalDelete, onSignalTypeSelect } = props;

    const { title, description } = MODAL_CONTENT_BY_SOURCE[signalsSource];

    return (
        <SignalsModal isOpen={isOpen}>
            <ModalHeader onClose={onClose}>
                <ModalHeaderContent
                    title={title}
                    description={description}
                />
            </ModalHeader>

            <SignalsManagementView
                viewModel={viewModel}
                initialSelectedType={initialSelectedType}
                onSignalCreate={onSignalCreate}
                onSignalEdit={onSignalEdit}
                onSignalDelete={onSignalDelete}
                onSignalTypeSelect={onSignalTypeSelect}
            />
        </SignalsModal>
    );
};

export default SignalsManagementModal;
